module.exports = __webpack_public_path__ + "img/berlinerkranse_done_closeup.8f5d8da8.jpg";